import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'lightTagBattery' })
export class LightTagBatteryPipe implements PipeTransform {
  transform(value?: number | null): string {
    if (value === undefined || value === null) {
      return '-';
    }

    const normalizedValue = value >= 0 && value <= 1 ? value * 100 : value;
    const roundedValue = Number.isInteger(normalizedValue)
      ? normalizedValue.toString()
      : normalizedValue.toFixed(2).replace(/\.?0+$/, '');

    return `${roundedValue}%`;
  }
}
